import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'fitscovery-ui-load-more-button',
  templateUrl: './ui-load-more-button.component.html',
  styleUrls: ['./ui-load-more-button.component.scss']
})
export class UiLoadMoreButtonComponent implements OnInit {
  @Input() showLoadMore: boolean;
  @Output() loadMoreClicked: EventEmitter<boolean>;

  constructor() {
    this.loadMoreClicked = new EventEmitter<boolean>();
  }

  ngOnInit(): void {
  }

  loadMore(): void {
    this.loadMoreClicked.emit(true);
  }

}
